import React, { useMemo } from "react";
import { Offcanvas } from "react-bootstrap";
const CustomerCare = ({ showHelp, setShowHelp }) => {
  const backdrop = useMemo(
    () => ({
      name: "Eable backdrop",
      scroll: false,
      backdrop: true,
    }),
    []
  );
  return (
    <Offcanvas
      show={showHelp}
      placement="bottom"
      onHide={() => setShowHelp(false)}
      className="h-auto bg-tr"
      {...backdrop}
    >
      <Offcanvas.Body>
        <div className="d-flex" onClick={()=>setShowHelp(false)}>
          <div className="bi bi-x-circle fs-lg mx-auto text-light"></div>
        </div>
        <div className="offcanvas-header">
          <h3 className="offset-title">Customer care</h3>
        </div>
        <div className="offcanvas-body bg-white d-flex p-16">
          <a className="bi bi-telephone btn-support me-2" href="tel:8295375479">
            <span className="mx-auto">Call us now</span>
          </a>
          <a
            className="bi bi-whatsapp btn-support"
            href={`whatsapp://send?phone=918295375479&text=I need help`}
          >
            <span className="mx-auto">Whatsapp</span>
          </a>
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default CustomerCare;
